<template>
  <div>
    <ProgressTracker
      :steps="steps"
      :showCheckMarkForCompletedStep="true"
      :linkItems="linkItems"
      class="task-progress-tracker"
      @change="onChange"
    />
  </div>
</template>
<script>
import ProgressTracker from '@components/ProgressTracker.vue'
import * as taskRequestManager from '@managers/taskRequestManager'
import * as estimateManager from '@managers/estimateManager'
import * as dialogs from '@libs/dialogs'
import * as requestPostManager from '@managers/requestPostManager'
import * as utils from '@libs/utils'
import * as orderManager from '@managers/orderManager'
import * as logManager from '@managers/logManager'
import * as moment from 'moment'
import { AKBS_SUB_TASK } from '@libs/constantsAKBS'
import { isSendTask, openAkbsOutputFromTask, isRecruitTask, openAkbsRecruit, isBugyoTask, openAkbsOutputBugyo, isContractReturnTask, openAkbsContractReturn, isDocKeepTask, openAkbsRegisteredDocs, isEmergencyTask, openAkbsRegisteredEmergency } from '@libs/akbsOutputLink'

// 雇い入れ（清掃員）のメインタスクのサブタスクに出す項目（選択肢の一番上）
// 新しい雇い入れ（dcNew2）：清掃員の申請画面（雇用指示登録画面）へ。古い雇い入れ：登録済み一覧でその清掃員を開く
const EMPLOYMENT_FORM_LABEL = '雇用指示登録画面へ'
const REGISTERED_LIST_LABEL = '登録済み一覧へ'
// 「●●送付」のサブタスクに出す項目（上の項目のすぐ下）：出力画面を別タブで開く
const OUTPUT_LABEL = '出力画面へ'
// 「●●返送確認」のサブタスク（雇い入れ（清掃員）だけ）：出力画面の契約書返送タブを、その清掃員コードで検索した状態で開く
const CONTRACT_RETURN_LABEL = '出力画面（契約書返送）へ'
// 「●●返送保管」のサブタスク（雇い入れ（清掃員）だけ）：登録済み一覧でその清掃員の「書類」タブを開く
const DOC_KEEP_LABEL = '書類添付画面へ'
// 「交通費・緊急連絡先登録」のサブタスク（雇い入れ（清掃員）だけ）：登録済み一覧でその清掃員の「緊急連絡先」タブを開く
const EMERGENCY_LABEL = '緊急連絡先画面へ'
// 別の画面へ移る項目（完了・未完了と見分けがつくよう、進み表で色を変える）
const LINK_ITEMS = [
  EMPLOYMENT_FORM_LABEL,
  REGISTERED_LIST_LABEL,
  OUTPUT_LABEL,
  CONTRACT_RETURN_LABEL,
  DOC_KEEP_LABEL,
  EMERGENCY_LABEL,
  '欠員募集へ',
  '見積画面を開く',
  '見積参照画面を開く',
  '受注画面（配信テンプレート）を開く',
  '受注画面を開く'
]

export default {
  components: {
    ProgressTracker,
  },

  props: ['record'],

  data() {
    return {
      // 見積りデータ
      estimate: {},
      // 別の画面へ移る項目の名前（進み表へ渡して色を変える）
      linkItems: LINK_ITEMS
    }
  },

  computed: {
    steps() {
      let steps = []

      if (this.record.subTasks && this.record.subTasks.length) {
        steps = this.setStep(this.record.subTasks, this.record)
      }

      return steps
    },

    dual() {
      return this.$store.getters.dualPosition
    },

    dentatsuDep() {
      return this.$store.getters.transDepartmentList
    },

    userName() {
      // ログインユーザー名
      let name = this.$store.getters.user.user_name
      name = utils.deleteSpace(utils.deleteKana(name))
      return name
    }
  },

  methods: {
    /**
     * 編集・完了できるか確認
     */
    async checkCanEdit(data) {
      // メインが完了していたら編集不可
      if (this.record.status == 'done') {
        await dialogs.showErrorDialog('変更できません', 'メインが完了しているため、変更できません。')
        return false
      } else if (this.record.status == 'remove') {
        await dialogs.showErrorDialog('変更できません', 'メインが取消されているため、変更できません。')
        return false
      }

      // 管理者権限はOK
      const auth = this.$store.getters.auth
      if (auth.adminAuth) {
        return true
      }

      // ログインユーザーがメイン担当者の場合、OK
      let main = utils.deleteSpace(utils.deleteKana(this.record.toStaffName))
      if (this.userName == main) {
        return true
      }

      // ログインユーザーがメイン依頼者の場合、OK
      let irai = utils.deleteSpace(utils.deleteKana(this.record.byUser))
      if (this.userName == irai) {
        return true
      }

      // ログインユーザーがサブ担当者の場合、OK
      let tanto = utils.deleteSpace(utils.deleteKana(data.data.toStaffName))
      if (this.userName == tanto) {
        return true
      }
      
      console.log('メイン')
      console.log(this.record)

      // メイン担当者が未定の場合、メインと同じ部署の人もOK
      if (main == '未定') {
        // ユーザーの主な所属部署（兼任含む）
        if (this.dual && this.dual.length) {
          for (let i = 0; i < this.dual.length; i++) {
            const tar = this.dual[i]
            // メインの部署と同じならOK
            if (tar.departmentName == this.record.toDepartment || tar.departmentId == this.record.toDepartmentId) {
              return true
            }
          }
        }

        // デンタツ部署での確認
        if (this.dentatsuDep && this.dentatsuDep.length) {
          // メインに該当するデンタツ部署マスタ情報取得
          let dentatsu = this.dentatsuDep.find((r) => {
            return (r.name == this.record.toDepartment || r.departmentId == this.record.toDepartmentId)
          })
          // 該当のデンタツに紐づく部署の人はOK（RLS_デンタツならRLS全員OK）
          if (dentatsu && dentatsu.transDepartment && this.dual && this.dual.length) {
            for (let i = 0; i < this.dual.length; i++) {
              const d = this.dual[i]
              if (d.departmentId == dentatsu.transDepartment) {
                return true
              }
            }
          }
        }
      }

      // サブと同じ部署の人はOK
      if (this.dual && this.dual.length) {
        // サブがデンタツ部署の場合、紐づくマスタデータを取得
        const dentatsu = this.dentatsuDep.find((r) => {
          return (r.name == data.data.departmentName || r.departmentId == data.data.departmentId)
        })

        for (let j = 0; j < this.dual.length; j++) {
          const tar = this.dual[j]

          // 主な部署が同じ場合はOK
          if (tar.departmentName == data.data.departmentName || tar.departmentId == data.data.departmentId) {
            return true
          }

          // デンタツの場合
          if (dentatsu && dentatsu.transDepartment) {
            if (tar.departmentId == dentatsu.transDepartment) {
              return true
            }
          }
        }
      }
      await dialogs.showErrorDialog('変更できません', '担当者と同じ部署でないため、変更できません。')
      return false
    },

    /**
     * メニュ－リスト クリックイベント
     */
    async onChange(selectedValue, step) {
      // AKBS の申請のサブタスク（登録申請・承認）：申請画面を別タブで開くだけ（完了は申請・AKBS登録で自動になる）
      if (step.akbsRoute && selectedValue === step.akbsLabel) {
        window.open(this.$router.resolve(step.akbsRoute).href, '_blank')
        return
      }

      // 雇い入れ（清掃員）のメインタスク：雇用指示登録画面（新しい雇い入れ）か登録済み一覧（古い雇い入れ）を別タブで開く
      if (selectedValue === EMPLOYMENT_FORM_LABEL || selectedValue === REGISTERED_LIST_LABEL) {
        const link = this.employmentLink(this.record)
        if (link) {
          window.open(this.$router.resolve(link.route).href, '_blank')
        }
        return
      }

      if (selectedValue == '完了にする' || selectedValue == '未完了に戻す' || selectedValue.task) {
        // 編集権限がなければ編集不可
        const auth = await this.checkCanEdit(step)
        if (!auth) {
          return
        }
      }

      if (selectedValue === '完了にする') {
        // 完了日をセット
        step.data.doneDate = moment().format('YYYY-MM-DD HH:mm:ss')
        step.data.doneStaffName = this.$store.getters.user.user_name

        if (step.data.type == 'task_request') {
          if (step.data.status == 'done') {
            await dialogs.showErrorDialog('サブタスクのステータス', 'すでに完了しています。')
            return
          }

          // 原本提出の場合
          if (step.data.requestTask.indexOf('原本提出') > 0 && this.record.category[0] == '非公開依頼' && (this.record.apology || this.record.reflect)) {
            if (!this.record.commonFile || !this.record.commonFile.url) {
              await dialogs.showErrorDialog('原本 未添付', 'メインタスクに原本が添付されていないため、完了できません。')
              return
            }
          }

          let result
          let refresh = false

          // 最終完了タスクが「1」の場合
          if (step.data.finalCompletionTask == "1") {
            // リクエストポストIDを元にリクエストポストに紐づく、サブタスクを検索
            let subTasks = await taskRequestManager.getByRequestPostId(this, step.data.requestPostId, null)

            // 完了するサブタスク以外のサブタスクがdoneになっているか
            let filterData = subTasks.filter(s => s._id != step.data._id)
            let result2 = filterData.every(function(val){
              return val.status == 'done'
            })

            // trueの場合、サブタスクのステータスをdoneにする
            if (result2) {
              step.data.status = 'done'
              result = await taskRequestManager.update(this, step.data)

              // postgresに登録
              await taskRequestManager.saveEstimateSubmission(step.data, this.$store.getters.user.id, step.subTask)
            } else {
              await dialogs.showErrorDialog('サブタスクのステータス', '他のタスクを完了してから、再度行ってください。')
              return
            }
          } else {
            // statusを完了にする(画面の色が即変わるようにここでステータスを変更)
            step.data.status = 'done'
            result = await taskRequestManager.update(this, step.data)
            // postgresに登録
            await taskRequestManager.saveEstimateSubmission(step.data, this.$store.getters.user.id, step.subTask)
          }

          // サブタスクのステータスが全てdoneの場合、リクエストポストのステータスをdoneにする
          let subTasks = await taskRequestManager.getByRequestPostId(this, step.data.requestPostId, null)
          let subTasksStatusResult = subTasks.every(function(val){
            return val.status == 'done'
          })
          if (subTasksStatusResult) {
            const result3 = requestPostManager.markAsDone(this, step.data.requestPostId)
            if (result3) {
              const requestPost = await requestPostManager.getRequestPost(this, step.data.requestPostId)
              requestPost.status = 'done'

              // DC面接の場合、採用であれば雇い入れタスク登録
              await requestPostManager.autoEmployTaskSave(this, requestPost)

              logManager.recording(this, logManager.Loglevel.INFO, 'メインタスク', 'ステータス完了', 'メインタスク（お問い合わせ番号：' + requestPost.requestNo + '）のステータスを完了しました。')
              refresh = true
            }
          }

          if (result) {
            await dialogs.showSuccessDialog('サブタスクのステータス変更', 'ステータスを完了にしました。')
            // 追加サブ設定
            await this.addSetSubTask(step.data)
            if (step.data.subTaskNo) {
              logManager.recording(this, logManager.Loglevel.INFO, 'サブタスク', 'ステータス完了', 'サブタスク（お問い合わせ番号：' + step.data.subTaskNo + '）のステータスを完了しました。')
            } else {
              logManager.recording(this, logManager.Loglevel.INFO, 'サブタスク', 'ステータス完了', 'サブタスクのステータスを完了しました。')
            }
          } else {
            await dialogs.showErrorDialog('サブタスクのステータス変更', 'ステータスの変更ができませんでした。')
          }

          if (refresh) this.$emit("toParent", "refresh", null)
        } else if (step.data.type == 'task_request_order') {
          if (step.data.status == 'done') {
            await dialogs.showErrorDialog('受注サブタスクのステータス', 'すでに完了しています。')
            return
          }

          // 初回作業日程連絡サブの場合
          if (step.data.requestTask.includes('初回作業日程連絡')) {
            this.$emit('changeLoading', true)
            // 区分と初回作業日メモを取得
            const res = await orderManager.getClassStartMemo(this, step.data.orderId)
            this.$emit('changeLoading', false)
            // スポットで、初回作業日未入力の場合
            if (res.classification[0] == '3' && !res.startMemo) {
              await dialogs.showErrorDialog('「初回作業日」未入力', '「スポット」の場合は「初回作業日」入力必須です。\r\nサブタスク画面からでも入力可能です。')
              return
            }
          }

          let result
          let refresh = false

          // 最終完了タスクが「1」の場合
          if (step.data.finalCompletionTask == "1") {
            // 受注IDを元に受注に紐づく、サブタスクを検索
            let subTasks = await taskRequestManager.getByOrderId(this, step.data.orderId, null)

            // 完了するサブタスク以外のサブタスクがdoneになっているか
            let filterData = subTasks.filter(s => s._id != step.data._id)
            let result2 = filterData.every(function(val){
              return val.status == 'done'
            })

            // trueの場合、サブタスクのステータスをdoneにする
            if (result2) {
              step.data.status = 'done'
              result = await taskRequestManager.orderTaskRequestUpdate(this, step.data)
            } else {
              await dialogs.showErrorDialog('受注サブタスクのステータス', '他のタスクを完了してから、再度行ってください。')
              return
            }
          } else {
            // statusを完了にする(画面の色が即変わるようにここでステータスを変更)
            step.data.status = 'done'
            result = await taskRequestManager.orderTaskRequestUpdate(this, step.data)
          }

          // サブタスクのステータスが全てdoneの場合、リクエストポストのステータスをdoneにする
          let subTasks = await taskRequestManager.getByOrderId(this, step.data.orderId, null)
          let subTasksStatusResult = subTasks.every(function(val){
            return val.status == 'done'
          })
          if (subTasksStatusResult) {
            const result3 = orderManager.markAsDone(this, step.data.orderId)
            if (result3) {
              const order = await orderManager.getOrderData(this, step.data.orderId)
              order.status = 'done'

              // 見積りのデータの受注ステータス更新、完了にした人を保存
              await this.setEstimateDataForOrder(order)

              logManager.recording(this, logManager.Loglevel.INFO, '受注タスク', 'ステータス完了', '受注タスク（お問い合わせ番号：' + order.requestNo + '）のステータスを完了しました。')
              refresh = true
            }
          }

          if (result) {
            await dialogs.showSuccessDialog('受注サブタスクのステータス', 'ステータスを完了にしました。')
            // 追加サブ設定
            await this.addSetSubTask(step.data)
            if (step.data.subTaskNo) {
              logManager.recording(this, logManager.Loglevel.INFO, '受注サブタスク', 'ステータス完了', '受注サブタスク（お問い合わせ番号：' + step.data.subTaskNo + '）のステータスを完了しました。')
            } else {
              logManager.recording(this, logManager.Loglevel.INFO, '受注サブタスク', 'ステータス完了', '受注サブタスクのステータスを完了しました。')
            }
          } else {
            await dialogs.showErrorDialog('受注サブタスクのステータス', 'ステータスの変更ができませんでした。')
          }

          if (refresh) this.$emit("toParent", "refresh", null)
        }
      }

      else if (selectedValue === '未完了に戻す') {
        // 完了日を削除
        step.data.doneDate = null
        step.data.doneStaffName = null

        if (step.data.type == 'task_request') {
          if (step.data.status == 'open') {
            await dialogs.showErrorDialog('サブタスクのステータス', 'まだ未完了です。')
            return
          }
          // statusを未完了にする(画面の色が即変わるようにここでステータスを変更)
          step.data.status = 'open'
          let result = await taskRequestManager.update(this, step.data)
          if (result) {
            await dialogs.showSuccessDialog('サブタスクのステータス変更', 'ステータス未完了に戻しました。')
            // postgresに登録
            await taskRequestManager.saveEstimateSubmission(step.data, this.$store.getters.user.id, step.subTask)
            if (step.data.subTaskNo) {
              logManager.recording(this, logManager.Loglevel.INFO, 'サブタスク', 'ステータス未完了', 'サブタスク（お問い合わせ番号：' + step.data.subTaskNo + '）のステータスを未完了に戻しました。')
            } else {
              logManager.recording(this, logManager.Loglevel.INFO, 'サブタスク', 'ステータス未完了', 'サブタスクのステータスを未完了に戻しました。')
            }
          } else {
            await dialogs.showErrorDialog('サブタスクのステータス変更', 'ステータスの変更ができませんでした。')
          }
        } else if (step.data.type == 'task_request_order') {
          if (step.data.status == 'open') {
            await dialogs.showErrorDialog('受注サブタスクのステータス', 'まだ未完了です。')
            return
          }
          // statusを未完了にする(画面の色が即変わるようにここでステータスを変更)
          step.data.status = 'open'
          let result = await taskRequestManager.orderTaskRequestUpdate(this, step.data)
          if (result) {
            await dialogs.showSuccessDialog('受注サブタスクのステータス', 'ステータス未完了に戻しました。')
            if (step.data.subTaskNo) {
              logManager.recording(this, logManager.Loglevel.INFO, '受注サブタスク', 'ステータス未完了', '受注サブタスク（お問い合わせ番号：' + step.data.subTaskNo + '）のステータスを未完了に戻しました。')
            } else {
              logManager.recording(this, logManager.Loglevel.INFO, '受注サブタスク', 'ステータス未完了', '受注サブタスクのステータスを未完了に戻しました。')
            }
          } else {
            await dialogs.showErrorDialog('受注サブタスクのステータス', 'ステータスの変更ができませんでした。')
          }
        }
      }

      else if (selectedValue === '見積画面を開く') {
        // 「見積作成」が含まれていたら、見積り画面に遷移
        if (step.value.match(/見積作成/)) {
          const estimates = await estimateManager.getEstimateByTaskRequestId(this, step.data._id)
          if (estimates && estimates.length > 1) {
            // 対象の見積を取得、複数あれば選択
            this.$emit("toParent", 'showEstimateSelector', step.data)
          } else if (estimates.length == 1) {
            // 見積１件 ⇒ 詳細画面へ遷移
            this.$router.push({
              name: 'EstimateForm',
              query: {
                estimateNo: estimates[0].estimateNo
              }
            })
          } else {
            // 見積無し ⇒ 新規作成
            this.$router.push({
              name: 'EstimateForm',
              query: {
                taskRequestId: step.data._id,
                requestPostId: step.data.requestPostId
              }
            })
          }
        }
      }

      else if (selectedValue === '見積参照画面を開く') {
        if (!step.data.estimateNo) {
          await dialogs.showErrorDialog('見積りNo取得失敗', '見積り参照画面が開けません。')
        } else {
          const route = this.$router.resolve({
            name: 'EstimateView',
            query: {
              estimateNo: step.data.estimateNo
            }
          })
          window.open(route.href, '_brank')
        }
      }

      else if (selectedValue === '受注画面（配信テンプレート）を開く') {
        if (!step.data.orderId) {
          await dialogs.showErrorDialog('受注No取得失敗', '受注画面が開けません。')
        } else {
          const route = this.$router.resolve({
            name: 'RequestPost',
            query: {
              mode: 6,
              orderId: step.data.orderId,
              position: 'template'
            }
          })
          window.open(route.href, '_brank')
        }
      }

      else if (selectedValue === '受注画面を開く') {
        if (!step.data.orderId) {
          await dialogs.showErrorDialog('受注No取得失敗', '受注画面が開けません。')
        } else {
          const route = this.$router.resolve({
            name: 'RequestPost',
            query: {
              mode: 6,
              orderId: step.data.orderId
            }
          })
          window.open(route.href, '_brank')
        }
      }

      else if (selectedValue === '送付状作成') {
        this.$emit("toParent", 'coverLetterShow', step.data)
      }

      // 清掃員への送付：出力画面を別タブで開く（清掃員にチェック・一式 ON の状態。サブタスクの requestPostId が雇い入れメインタスクの _id）
      else if (selectedValue === OUTPUT_LABEL) {
        // 「給与奉行●●」：出力画面の「給与奉行」タブ（人の検索はしない）
        if (isBugyoTask(step.data)) {
          openAkbsOutputBugyo(this)
        } else {
          await openAkbsOutputFromTask(this, step.data.requestPostId, step.data)
        }
      }

      // 「●●返送確認」：出力画面の契約書返送タブ（メインタスクの清掃員コードで検索した状態）
      else if (selectedValue === CONTRACT_RETURN_LABEL) {
        await openAkbsContractReturn(this, this.record.employmentStaffNumber)
      }

      // 「●●返送保管」：登録済み一覧でその清掃員の「書類」タブ
      else if (selectedValue === DOC_KEEP_LABEL) {
        await openAkbsRegisteredDocs(this, this.record.employmentStaffNumber)
      }

      // 「交通費・緊急連絡先登録」：登録済み一覧でその清掃員の「緊急連絡先」タブ
      else if (selectedValue === EMERGENCY_LABEL) {
        await openAkbsRegisteredEmergency(this, this.record.employmentStaffNumber)
      }

      // 求人確認：AKBS の「欠員募集」画面を別タブで開く
      else if (selectedValue === '欠員募集へ') {
        openAkbsRecruit()
      }

      else if (selectedValue === '採用候補チャット送信して完了にする') {
        // サブタスク画面へ
        this.$router.push({
          name: 'TaskRequest',
          query: { requestPostId: step.data.requestPostId, interviewsSendChat: 'open' }
        })
      }

      // 詳細タスクをクリックした場合
      else if (selectedValue.task) {
        // console.log(step)
        if (step.data.status == 'done') {
          await dialogs.showErrorDialog('変更できません', 'このサブタスクは完了しているため、詳細タスクを変更できません。\r\n詳細画面で修正してください。')
          return
        }
        // 詳細タスク状態
        let detailIsDone = false
        // サブタスクのステータスを完了にするか
        let subIsDone = false
        // メインタスクのステータスを完了にするか
        let mainIsDone = false

        if (selectedValue.isDone) {
          const dRes = await dialogs.showConfirmDialog('未完了に戻しますか？', 'こちらの詳細タスクを未完了に戻します。')
          if (dRes != 'YES') {
            return
          }
          selectedValue.isDone = false
          selectedValue.doneDate = null
          selectedValue.doneStaffName = null
          detailIsDone = false

        } else {
          const dRes = await dialogs.showConfirmDialog('完了にしますか？', 'こちらの詳細タスクを完了にします。')
          if (dRes != 'YES') {
            return
          }
          selectedValue.isDone = true
          selectedValue.doneDate = moment().format('YYYY-MM-DD HH:mm:ss')
          selectedValue.doneStaffName = this.$store.getters.user.user_name
          detailIsDone = true

          // 他の詳細タスクの状態を確認
          if (step.selection && step.selection.length) {
            // 選択肢には画面へ移る項目（文字列）も混ざるので、詳細タスクだけで見る
            const res = step.selection.filter(det => det && det.task).some(det => !det.isDone)

            // 詳細タスクがすべて完了している場合
            if (!res) {
              step.data.status = 'done'
              step.data.doneDate = moment().format('YYYY-MM-DD HH:mm:ss')
              step.data.doneStaffName = this.$store.getters.user.user_name
              subIsDone = true
              // 最終完了タスクでない場合
              if (step.data.finalCompletionTask != '1') {
                await dialogs.showInfoDialog('サブタスクを完了にします', '全ての詳細タスクが完了したので、こちらのサブタスクを完了にします。')

                // 最終完了の場合は、他のが完了していたら完了にする
              } else {
                let isDone = step.subTask.every(function(val){
                  return val.status == 'done'
                })

                // 他のサブも全て完了になっている場合
                if (isDone) {
                  // メインも完了とする
                  mainIsDone = true
                  await dialogs.showInfoDialog('サブタスク、メインタスクを完了にします', '全ての詳細タスクとサブタスクが完了したので、こちらのサブタスクとメインタスクを完了にします。')

                // 未完了のサブがある場合、サブを完了にしない
                } else {
                  step.data.status = 'open'
                  step.data.doneDate = null
                  step.data.doneStaffName = null
                  subIsDone = false
                }
              }
            }
          }
        }

        // データ保存
        await this.detailChange(step.data.type, step, subIsDone, mainIsDone, detailIsDone, selectedValue.task)
      }
    },

    /**
     * 完了時にセットされているサブタスクを追加
     */
    async addSetSubTask(task) {
      // 追加タスク設定がある場合
      if (task.addTask) {
        const add = task.addTask
        // if (add.addYes) {
        const log = await dialogs.showConfirmDialog(add.requestTask + 'を追加しますか？', (add.addInfo || 'どちらか選択してください。'), '追加する', '追加不要')
        if (log != 'YES') {
          return null
        }
        // }

        if (task.type == 'task_request') {
          this.$router.push({
            name: 'TaskRequest',
            query: {
              requestPostId: task.requestPostId
            },
            params: {
              addTaskData: task
            }
          })
        } else {
          this.$router.push({
            name: 'TaskRequest',
            query: {
              orderId: task.orderId,
              mode: 1
            },
            params: {
              addTaskData: task
            }
          })
        }
      }
    },

    /**
     * カラー設定
     */
    setStatusColor(task) {
      // 色判定用のプロパティー
      task.statusColor = task.status

      // ステータスが未完了
      if (task.statusColor == 'open') {
        // 期限が今日のものは色をオレンジに変更するため、ステータス名変更
        if (task.limitDate == utils.getToday()) {
          task.statusColor = 'limitToday'

        // 期限が過ぎているもの（期限が昨日以降）
        } else if (new Date(task.limitDate) < new Date(utils.getToday())) {
          task.statusColor = 'limitOut'
        }
      }
    },

    /**
     * 詳細タスク変更
     * @param type タイプ
     * @param step サブデータ
     * @param subIsDone サブ完了フラグ
     * @param mainIsDone メイン完了フラグ
     * @param detailIsDone 詳細タスク完了状態
     */
    async detailChange(type, step, subIsDone, mainIsDone, detailIsDone, detailName) {
      // 受注ではない場合
      if (type == 'task_request') {
        // サブ更新
        let result = await taskRequestManager.update(this, step.data)
        if (!result) {
          alert('エラーが発生しました。')
          return
        }
        // 見積集計用の完了日（提出タスク）保存
        if (subIsDone) {
          await taskRequestManager.saveEstimateSubmission(step.data, this.$store.getters.user.id, step.subTask)
        }
        // メイン更新
        if (mainIsDone) {
          await requestPostManager.markAsDone(this, step.data.requestPostId)
        }

      // 受注の場合
      } else {
        // サブ更新
        let result = await taskRequestManager.orderTaskRequestUpdate(this, step.data)
        if (!result) {
          alert('エラーが発生しました。')
          return
        }
        // メイン更新
        if (mainIsDone) {
          await orderManager.markAsDone(this, step.data.orderId)

          const order = await orderManager.getOrderData(this, step.data.orderId)
          // 見積りのデータの受注ステータス更新、完了にした人を保存
          await this.setEstimateDataForOrder(order)
        }
      }

      // ログ登録
      let no = step.data.taskRequestRequestNo || step.data.orderTaskRequestOrderNo
      no = `メインのお問い合わせ番号（${no}） `

      let sub = step.data.requestTask
      sub = `サブタスク（${sub}）の`

      let status = 'を完了しました。'
      if (!detailIsDone) {
        status = 'を未完了に戻しました。'
      }

      let txt = no + sub +  '詳細タスク（' + detailName + '）' + status

      // サブやメインも完了する場合
      if (subIsDone) {
        let donTxt = 'サブタスク'
        if (mainIsDone) {
          donTxt += '・メインタスク'
        }
        donTxt += 'も完了しました。'
        txt += '\r\nそれに伴い' + donTxt
      }

      logManager.recording(this, logManager.Loglevel.INFO, 'サブの詳細タスク', 'ステータス変更', txt)

      // メイン完了した場合、画面をリロードする
      if (mainIsDone) {
        this.$emit('toParent', 'refresh', null)
      }
    },

    /**
     * サブタスクの表示データを成形
     * @param tasks サブタスクデータ
     * @param main メインデータ含む
     */
    setStep(tasks, main) {
      let steps = []
      if (tasks && tasks.length > 0) {
        steps = tasks.map((r) => {
          this.setStatusColor(r)

          let v =  ''
          // 完了タスクは、タスク完了者を表示
          // 未完了タスクは、担当者を表示
          if (r.status == 'done' && r.doneStaffName) {
            v = r.requestTask + '\r\n' + utils.deleteKana(r.doneStaffName)
          } else {
            if (r.toStaffName == '未定') {
              v = r.requestTask + '\r\n' + r.departmentName
            } else {
              v = r.requestTask + '\r\n' + utils.deleteKana(r.toStaffName)
            }
          }

          let selection = ['完了にする', '未完了に戻す']
          if (r.details && r.details.length) {
            // 画面へ移る項目（文字列）を足すので、コピーにする（details そのものに混ぜると保存されてしまう）
            selection = r.details.slice()
          }

          const val = {
            value: v,
            selection,
            status: r.statusColor,
            data: r,
            subTask: tasks
          }

          if (main.status == 'remove') {
            val.selection = []
            return val
          }

          // AKBS の申請のサブタスク（契約詳細登録申請・契約詳細承認・雇用指示登録申請・雇用指示承認）は手で完了にできない
          // （申請したら登録申請が、AKBS に登録したら承認が自動で完了になる。サブタスク画面と同じ決まり。バックは akbsSubTask.js）
          // 代わりに、申請画面へ移る項目だけ出す（2026-09-23）
          const akbs = this.akbsLink(r, main)
          if (akbs) {
            val.selection = [akbs.label]
            val.akbsLabel = akbs.label
            val.akbsRoute = akbs.route
            return val
          }

          // 雇い入れ（清掃員）のメインタスク：どのサブタスクからも清掃員の画面へ移れるよう、選択肢の一番上に出す
          // （新しい雇い入れは雇用指示登録画面、古い雇い入れは登録済み一覧。選択肢が無いサブタスクには出さない）
          const employment = this.employmentLink(main)
          if (employment && val.selection.length) {
            val.selection = [employment.label].concat(val.selection)
          }
          // 清掃員への送付（雇い入れ（清掃員）の「清掃員に送付」「エプロン・退職届返却用封筒送付」など）：出力画面を別タブで開く
          // 上の項目のすぐ下（無ければ一番上）に出す
          // 一覧のメインタスクはカテゴリーがそろっていないことがあるので名前だけで出し、開くときにバックが雇い入れ（清掃員）か確かめる
          // 「給与奉行●●」（雇い入れ（清掃員）だけ）：出力画面の「給与奉行」タブを開く。名前に「送付」も含むときはこちらを優先
          if (employment && isBugyoTask(r)) {
            val.selection.splice(1, 0, OUTPUT_LABEL)
          // 「●●返送確認」（雇い入れ（清掃員）だけ）：出力画面の契約書返送タブ
          } else if (employment && isContractReturnTask(r)) {
            val.selection.splice(1, 0, CONTRACT_RETURN_LABEL)
          // 「●●返送保管」（雇い入れ（清掃員）だけ）：登録済み一覧の「書類」タブ
          } else if (employment && isDocKeepTask(r)) {
            val.selection.splice(1, 0, DOC_KEEP_LABEL)
          // 「交通費・緊急連絡先登録」（雇い入れ（清掃員）だけ）：登録済み一覧の「緊急連絡先」タブ
          } else if (employment && isEmergencyTask(r)) {
            val.selection.splice(1, 0, EMERGENCY_LABEL)
          } else if (isSendTask(r) && !main.estimateNo) {
            val.selection.splice(employment ? 1 : 0, 0, OUTPUT_LABEL)
          }

          // 「●●送付」など送付以外に文言がついている場合があるため、ここではreturnしない
          if (r.requestTask.match(/送付/) && main.estimateNo) {
            val.data = { ...val.data, estimateNo: main.estimateNo }
            val.selection.push('送付状作成')
          }
          // 求人確認：AKBS の「欠員募集」画面を別タブで開く
          if (isRecruitTask(r)) {
            val.selection.push('欠員募集へ')
          }

          if (r.requestTask.match(/見積作成/)) {
            val.selection.push('見積画面を開く')
            return val
          } else if (r.requestTask.match(/契約書/)) {
            val.selection.push('見積参照画面を開く')
            if (main.estimateNo) {
              val.data = { ...val.data, estimateNo: main.estimateNo }
            }
            return val
          } else if (r.requestTask.match(/配信/)) {
            val.selection.push('受注画面（配信テンプレート）を開く')
            return val
          } else if (r.requestTask.match(/発注書/)) {
            val.selection.push('受注画面を開く')
            return val
          } else if (r.requestTask.match(/エナジャイザー完了確認/)) {
            val.selection = ['採用候補チャット送信して完了にする'].concat(val.selection)
            return val
          } else {
            return val
          }
        })
      }
      return steps
    },

    /**
     * AKBS の申請のサブタスクなら、申請画面へ移る項目の名前と行き先（そうでなければ null）
     * メインタスクのカテゴリーは見ず、サブタスクの名前だけで決める（ユーザー指示 2026-09-23。一覧のメインタスクにはカテゴリーや dcNew2 がそろっていないことがある）
     *   ・契約詳細登録申請・契約詳細承認 → 契約詳細入力画面（承認は承認者として開く）
     *   ・雇用指示登録申請・雇用指示承認 → 清掃員の申請画面（承認は承認者として開く）
     * @param {Object} r サブタスク
     * @param {Object} main メインタスク
     */
    akbsLink(r, main) {
      const name = String(r.requestTask || '')
      if (!main._id) {
        return null
      }
      if (name.includes(AKBS_SUB_TASK.CONTRACT_APPROVE)) {
        return { label: '契約詳細入力画面を開く（承認）', route: { name: 'AkbsContractForm', query: { requestPostId: main._id, approver: 'true' } } }
      }
      if (name.includes(AKBS_SUB_TASK.CONTRACT)) {
        return { label: '契約詳細入力画面を開く', route: { name: 'AkbsContractForm', query: { requestPostId: main._id } } }
      }
      if (name.includes(AKBS_SUB_TASK.EMPLOYMENT_APPROVE)) {
        return { label: '申請画面を開く（承認）', route: { name: 'AkbsInputForm', query: { requestPostId: main._id, from: 'employment', approver: 'true' } } }
      }
      if (name.includes(AKBS_SUB_TASK.EMPLOYMENT)) {
        return { label: '申請画面を開く', route: { name: 'AkbsInputForm', query: { requestPostId: main._id, from: 'employment' } } }
      }
      return null
    },

    /**
     * 雇い入れ（清掃員）のメインタスクなら、サブタスクの選択肢の一番上に出す項目の名前と行き先（そうでなければ null）
     *   ・新しい雇い入れ（dcNew2）→ 清掃員の申請画面（雇用指示登録画面。メインタスクの「雇用指示へ登録」と同じ行き先）
     *   ・古い雇い入れ → 登録済み一覧（清掃員コードがあればその人を選んだ状態で開く）
     * 古いメインタスクはカテゴリーが「雇い入れ」のままのことがあるので、社員（employmentRegularStaff）でなければ清掃員と見る
     * @param {Object} main メインタスク
     */
    employmentLink(main) {
      if (!main || !main._id || !Array.isArray(main.category)) {
        return null
      }
      const isCleaner = main.category.includes('雇い入れ（清掃員）') || (main.category.includes('雇い入れ') && !main.employmentRegularStaff)
      if (!isCleaner) {
        return null
      }
      if (main.dcNew2) {
        return { label: EMPLOYMENT_FORM_LABEL, route: { name: 'AkbsInputForm', query: { requestPostId: main._id, from: 'employment' } } }
      }
      const query = {}
      if (main.employmentStaffNumber) {
        query.staffCode = String(main.employmentStaffNumber)
      }
      return { label: REGISTERED_LIST_LABEL, route: { name: 'AkbsRegisteredList', query } }
    },

    /**
     * 受注タスク完了したら、見積に完了させた人の名前を登録
     */
    async setEstimateDataForOrder(order) {
      // ログインユーザー名
      let name = this.$store.getters.user.user_name
      name = utils.deleteKana(name)
      await estimateManager.changeOrderStatus(this, order.estimateNo, '受注完了', name)
    },
  }
}
</script>